import React from 'react';
import { CheckBox } from 'devextreme-react/check-box';
import './style.scss';

export default function Checkboxs() {
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Checked</div>
            <div className="form-value">
              <CheckBox defaultValue={true} />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Unchecked</div>
            <div className="form-value">
              <CheckBox defaultValue={false} />
            </div>
          </div>
        </div>
        <div className="form-col">  
          <div className="form-group">
            <div className="form-label">Disabled</div>
            <div className="form-value">
              <CheckBox
                disabled={true}
                defaultValue={true}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">With label</div>
            <div className="form-value">
              <CheckBox
                defaultValue={true}
                text="Label"
              />
            </div>
          </div>
        </div>
        <div className="form-col">  
          <div className="form-group">
            <div className="form-label">Custom size</div>
            <div className="form-value">
              <CheckBox
                defaultValue={true}
                iconSize={30}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
